export const CustomLogger = ({ ComponentName, ...props }) => {
  console.log("%c rendered ", "color: white; background-color: #2274A5", {
    ComponentName
  });
  console.log("%c Props ", "color: white; background-color: #95B46A", props);
};
